function SectionTwo(){
    return (
      <section className="section standOut ">
     <div className="section--bg standOut--bg"></div>
     <div className="section--main standOut--main flexCol">
        <h2 className="fs-heading-secondary fw-black">Stand out to the right audience</h2>
        <p className="section--para standOut--para txt-gray-mid">Using a collaborative formula of designers, researchers, photographers, videographers, and copywriters, we’ll build and extend your brand in digital places.</p>
        <a href="#" className="section--link standOut--link fw-bold">Learn More</a>
     </div>
      </section>
    )
};
export default SectionTwo